import { CashFastIcon } from './CashFastIcon';

/**
 * author: Jeff Anders
 * id A10E9739-AA80-4671-B744-ECB9934BB7E4
 * name cash-fast
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-fast.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const InstantDepositIcon = CashFastIcon;
export default InstantDepositIcon